import { useState } from 'react';
import { useLanguage } from '@/lib/i18n';
import { ExternalLink } from 'lucide-react';
import { Skeleton } from '@/components/ui/skeleton';

const SPOTIFY_EMBED_URL = "https://open.spotify.com/embed/playlist/64Y1vMO3wEbgeDHff8QBTU?utm_source=generator&theme=0";
const SPOTIFY_URL = "https://open.spotify.com/playlist/64Y1vMO3wEbgeDHff8QBTU";

export default function SpotifyEmbed() {
  const { t } = useLanguage();
  const [loaded, setLoaded] = useState(false);

  return (
    <div className="relative" data-testid="spotify-embed-container">
      {/* Glow effect */}
      <div className="absolute pointer-events-none -inset-2 bg-gradient-to-r from-[#7F00FF]/15 to-[#00E5FF]/15 rounded-3xl blur-2xl opacity-60 pulse-glow" />

      <div className="relative bg-[#0A0A0A] border border-white/[0.08] rounded-2xl overflow-hidden gradient-border">
        <div className="relative rounded-2xl overflow-hidden p-1">
          {!loaded && (
            <div className="absolute inset-0 z-10 flex flex-col gap-4 p-6 bg-[#0A0A0A]">
              <Skeleton className="h-8 w-48 bg-white/[0.04]" />
              <Skeleton className="h-4 w-32 bg-white/[0.04]" />
              <div className="flex-1 flex flex-col gap-3 mt-4">
                {[...Array(6)].map((_, i) => (
                  <Skeleton key={i} className="h-14 w-full bg-white/[0.04]" />
                ))}
              </div>
            </div>
          )}
          <iframe
            data-testid="spotify-iframe"
            src={SPOTIFY_EMBED_URL}
            width="100%"
            height="500"
            frameBorder="0"
            allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
            loading="lazy"
            onLoad={() => setLoaded(true)}
            className={`rounded-xl transition-opacity duration-700 ${loaded ? 'opacity-100' : 'opacity-0'}`}
            title="Zateviss Spotify Playlist"
            style={{ minHeight: '500px' }}
          />
        </div>
      </div>

      <div className="mt-5 text-center">
        <a
          href={SPOTIFY_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="spotify-external-link"
          className="inline-flex items-center z-10 gap-2 text-sm text-white/30 hover:text-[#1DB954] transition-colors duration-200"
        >
          {t('playlist_open')}
          <ExternalLink className="w-3.5 h-3.5" />
        </a>
      </div>
    </div>
  );
}
